import axios from 'axios';
import Portfolio from '../entity/portfolio.entity';

export default class PortfolioService {
  public static getPortfolios(businessUnitId: string, types?: string): Promise<Portfolio[]> {
    const query = types ? `?types=${types}` : '';
    return axios.get(`/api/v1/${businessUnitId}/portfolios${query}`)
      .then((response: any) => Portfolio.ofList(response.data));
  }
}
